module.exports = new __parcel__URL__("trello-left.4f52d13c.svg").toString();